const Fetcher = require('od-modules/utils/fetcher');

function checkinRepository(urlFormatter, ancillariesClient) {
    const module = {};

    module.getCheckinAvailability = function getCheckinAvailability(bookingId, citizenship = '') {
        citizenship = citizenship ? `&citizenship=${citizenship}` : '';
        return Fetcher.get(`${urlFormatter('checkinAvailability')}?bookingid=${bookingId}${citizenship}`)
            .json()
            .then(processUserResponse('checkinAvailability'));
    };

    module.getCheckinStatus = function getCheckinStatus(bookingId) {
        return Fetcher.get(`${urlFormatter('checkinstatus')}?bookingid=${bookingId}`)
            .json()
            .then(processUserResponse('checkinStatus'));
    };

    module.getCheckinData = function getCheckinData(bookingId, email) {
        return Fetcher.get(`${urlFormatter('checkin')}?bookingid=${bookingId}&email=${email}`)
            .json()
            .then(processUserResponse('checkinData'));
    };

    module.getCheckinSeatsAvailability = function getCheckinSeatsAvailability(bookingInfo) {
        return ancillariesClient.loadCheckInSeats(bookingInfo).then(processUserResponse('availableAncillariesOptionsDTO'));
    };

    module.createCheckinRequest = function createCheckinRequest(autoCheckinRequest) {
        return Fetcher.post(urlFormatter('checkin'), autoCheckinRequest).json();
    };

    return module;
}

function processUserResponse(property) {
    return function(res) {
        if (res.responseOK) {
            return res[property];
        }

        return Promise.reject(res.messageError);
    };
}

module.exports = {
    factory: checkinRepository,
};
